module.exports = __webpack_public_path__ + "media/practice-tab.8b1832d0.mp4";